"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldSelectList = exports.ModelMutatorSelectList = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorSelectList = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorSelectList, _super);
    function ModelMutatorSelectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorSelectList.prototype.manual = function (newText) {
        var option = this.field.schema.findOption(newText);
        if (option == null) {
            this.state.setFieldValue(this.field.id, null);
            return;
        }
        this.state.setFieldValue(this.field.id, option.value);
    };
    ModelMutatorSelectList.prototype.copy = function (from) {
        if (!from.hasValue()) {
            this.manual(null);
            return true;
        }
        var value = from.value;
        if (this.field.schema.findOption(value) != null) {
            this.manual(value);
            return true;
        }
        return false;
    };
    return ModelMutatorSelectList;
}(collection_field_1.ModelMutator));
exports.ModelMutatorSelectList = ModelMutatorSelectList;
var CollectionModelFieldSelectList = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldSelectList, _super);
    function CollectionModelFieldSelectList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldSelectList.isSelectListField = function (f) {
        return f.schema.type === CollectionModelFieldSelectList.TYPE;
    };
    Object.defineProperty(CollectionModelFieldSelectList.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorSelectList(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldSelectList.prototype, "value", {
        get: function () {
            return this.stateValue || this.schema.unselectedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldSelectList.prototype, "displayValue", {
        get: function () {
            var opt = this.schema.findOption(this.value);
            if (opt != null) {
                return opt.text;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldSelectList.prototype, "color", {
        get: function () {
            var opt = this.schema.findOption(this.value);
            if (opt != null) {
                return opt.color;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldSelectList.prototype.hasValue = function () {
        return this.value !== this.schema.unselectedValue;
    };
    CollectionModelFieldSelectList.TYPE = core_api_1.IkeFieldType.SELECT_LIST;
    return CollectionModelFieldSelectList;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldSelectList = CollectionModelFieldSelectList;
//# sourceMappingURL=select.list.field.js.map